import {
  SectionElement,
  defineElement,
  onClick,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/common-faq/common-faq.ts
var CommonFaq = class extends SectionElement {
  handleOpenButtonClick(elm) {
    const index = parseInt(elm.getAttribute("key"));
    if (this.accordions[index].isOpen) {
      this.accordions[index].close();
      this.chevrons[index].classList.remove("rotate-180");
    } else {
      this.chevrons.forEach((chevron) => {
        chevron.classList.remove("rotate-180");
      });
      this.accordions.forEach((accordion) => __async(this, null, function* () {
        yield accordion.close();
      }));
      this.accordions[index].open();
      this.chevrons[index].classList.add("rotate-180");
    }
  }
};
__decorateClass([
  queryAll("[data-accordion]")
], CommonFaq.prototype, "accordions", 2);
__decorateClass([
  queryAll("[data-chevron]")
], CommonFaq.prototype, "chevrons", 2);
__decorateClass([
  onClick("[data-open-button]")
], CommonFaq.prototype, "handleOpenButtonClick", 1);
CommonFaq = __decorateClass([
  defineElement("common-faq")
], CommonFaq);
export {
  CommonFaq
};
